<template>
  <b-navbar
    wrapper-class="container"
    :close-on-click="true"
    :spaced="spaced"
    :shadow="true"
  >
    <template #brand>
      <b-navbar-item tag="router-link" :to="{ path: '/' }" class="is-relative">
        <Brand :compact="!spaced" />
      </b-navbar-item>
    </template>

    <template #start>
      <!-- <b-navbar-item
        tag="router-link"
        :to="{ name: 'Directory' }"
        class="has-text-weight-bold"
      >{{$t('Directory')}}</b-navbar-item> -->
      <b-navbar-item
        tag="router-link"
        :to="{ name: 'StaticDirectory' }"
        class="has-text-weight-bold"
        >{{ $t("Browse") }}</b-navbar-item
      >
      <!-- <b-navbar-item
        tag="router-link"
        :to="{ name: 'TagDirectory' }"
        class="has-text-weight-bold"
        >{{ $t("Tags") }}</b-navbar-item
      > -->
      <b-navbar-item
        tag="router-link"
        :to="{ name: 'Search' }"
        class="has-text-weight-bold"
        >{{ $t("Search") }}</b-navbar-item
      >
    </template>
    <template #end>
      <b-navbar-item
        tag="router-link"
        :to="{ name: 'About' }"
        class="has-text-weight-bold"
        >{{ $t("About") }}</b-navbar-item
      >

       <b-navbar-item>
        <b-dropdown @change="setLanguage" v-model="$root.$i18n.locale">
          <a class="navbar-item" slot="trigger" role="button">
            <span class="has-text-weight-bold">{{ $t("Language") }}</span>
            <b-icon icon="caret-down"></b-icon>
          </a>

          <b-dropdown-item
            v-for="(lang, i) in languages"
            :key="`Lang${i}`"
            :value="lang.code"
          >
            {{ lang.label }}
          </b-dropdown-item>
        </b-dropdown>
      </b-navbar-item>

    </template>
  </b-navbar>
</template>

<script>
import Brand from "@/components/TheNavbarBrand.vue";
import config from '@/config';

import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("user");

export default {
  components: {
    Brand,
  },
  props: {
    spaced: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["isLoggedIn"]),
     languages() {
      return config.languages;
    },
  },
  mounted() {
    console.log(config)
  },
   methods: {
    setLanguage(value) {
      localStorage.setItem('lang',value)
    },
  },

};
</script>
<style scoped>
.navbar.is-spaced {
  padding: 0.25rem 0.25rem !important;
}
</style>
